export default __webpack_public_path__ + "static/media/boots_of_tribulation.798feb56.jpg";